const CARD = "cards/CARD";
const CARD_ERROR = "cards/CARD_ERROR";
const CARD_SUCCESS = "cards/CARD_SUCCESS";
const CARDS = "cards/CARDS";
const CARDS_ERROR = "cards/CARDS_ERROR";
const CARDS_SUCCESS = "cards/CARDS_SUCCESS";

const initialState = { cards: {}, isLoading: false };

const cards = (state = initialState, action) => {
  switch (action.type) {
    case CARD: {
      return {
        ...state,
        cards: { ...state.cards, [action.url]: { loading: true } },
      };
    }
    case CARD_ERROR: {
      return state;
    }
    case CARD_SUCCESS: {
      return {
        ...state,
        cards: { ...state.cards, [action.data.url]: action.data },
      };
    }
    case CARDS: {
      return { ...state, isLoading: true };
    }
    case CARDS_ERROR: {
      return state;
    }
    case CARDS_SUCCESS: {
      return { ...state, ...action.data, isLoading: false };
    }
    default: {
      return state;
    }
  }
};

export const addCards = (names) => async (dispatch, getState) => {
  dispatch({ cards, type: CARDS });
  try {
    const res = await fetch(`https://edhrec.com/api/cards/`, {
      body: JSON.stringify({ format: "dict", names }),
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
    });
    const data = await res.json();
    if (res.status !== 200) {
      return dispatch({ error: data.message, type: CARD_ERROR });
    }
    return dispatch({ data, type: CARDS_SUCCESS });
  } catch (e) {
    return dispatch({ error: e.message, type: CARDS_ERROR });
  }
};

export const addCard = (url) => async (dispatch) => {
  dispatch({ type: CARD, url });
  try {
    const res = await fetch(`https://json.edhrec.com/cards/${url}`);
    const data = await res.json();
    if (res.status !== 200) {
      return dispatch({ error: data.message, type: CARD_ERROR });
    }
    return dispatch({ data, type: CARD_SUCCESS });
  } catch (e) {
    return dispatch({ error: e.message, type: CARD_ERROR });
  }
};

export default cards;
